import type { Tone } from "@nymbl/nos2-rules";
import type { SignOffCellState } from "@/lib/team/signoff-grid";
import type { OffKind } from "@/lib/team/time-off";

/** Timeline cell fills: vacation royal, sick orange, holiday grey (mockup), other info. */
export const OFF_KIND_FILL: Record<OffKind, string> = {
  vacation: "bg-primary",
  sick: "bg-warning",
  holiday: "bg-muted-foreground/50",
  other: "bg-info",
};

/** Pending PTO: the same hue as an outline on an empty cell (Zack, 2026-10-15). */
export const OFF_KIND_OUTLINE: Record<OffKind, string> = {
  vacation: "border-2 border-primary bg-background",
  sick: "border-2 border-warning bg-background",
  holiday: "border-2 border-muted-foreground/60 bg-background",
  other: "border-2 border-info bg-background",
};

export const OFF_KIND_TONES: Record<OffKind, Tone> = {
  vacation: "info",
  sick: "warning",
  holiday: "neutral",
  other: "neutral",
};

export const SIGNOFF_CELL: Record<SignOffCellState, string> = {
  onTime: "bg-success-bg text-success",
  late: "bg-warning-bg text-warning",
  overdue: "border border-danger bg-background text-danger",
  open: "bg-muted text-muted-foreground",
};
